<template>
  <div>
    <div class="ssl-banner">
            <div class="inner-bound">
              <h1>SSL Certificate Monitoring</h1>
              <p>The SSL certificate monitoring service regularly checks the SSL certificate deployment status of each node. And if there's any issue with SSL certificate validity, security vulnerabilities and compliance, notifications will be made via Email, WeChat and SMS, thus thoroughly solving the operation and maintenance issues in SSL certificate management.</p>
            </div>
            <img src="/static/images/banner/ssl-certificate-monitoring.jpg" alt="SSL certificate monitoring" class="isPC">
            <img src="/static/images/banner/ssl-certificate-monitoring-phone.jpg" alt="SSL certificate monitoring" class="isPhone">
          </div>
          
          <div class="inner-bound padding2-60">
            <h2>Features of SSL Certificate Monitoring</h2>
            <div class="two-box three-noimg-box">
              <div>
                <h4>All-round Security Monitoring</h4>
                <p>Instantly monitor SSL certificate expiration dates, security vulnerability and compliance. Send security warnings through various ways to prevent SSL-related issues.</p>
              </div>
              <div>
                <h4>Hierarchical Permission Management</h4>
                <p>Integrates with enterprise IAM, gives the monitoring and notification permissions of the SSL certificates on different nodes to a number of employees, and realizes fine-grained SSL certificate security management.</p>
              </div>
              <div>
                <h4>Unified Certificate Monitoring Service</h4>
                <p>With high compatibility, one management panel can analyze and monitor the different brands and types of SSL certificates for all the nodes as well as their different application scenarios.</p>
              </div>
              <div>
                <h4>Flexible Configuration</h4>
                <p>Users can upgrade the number of monitoring nodes at any time and purchase on demand. At the same time, enterprise customers can contact technical support for localized monitoring service deployment.</p>
              </div>
            </div>
          </div>
          
          <div class="bound padding-60">
            <div class="inner-bound">
              <h2>SSL Certificate Monitoring Q&A</h2>
              <div class="faq">
                <h4><span>Q</span>If the number of monitoring nodes needs to be upgraded, how much will that cost?</h4>
                <div class="faq-info">
                  <span>A</span>
                  <p>Currently, there are two upgrading modes. One is purchasing a new monitoring service package, which has its own separate start and end dates, also billed annually independently from the original monitoring package. The other mode is upgrading the existing monitoring service package. Since the expiration date of the monitoring service package remains the same, the system only charges for the remaining days. For instance, if there are 100 days left until expiration, the charge will be 100/365 * annual fee.</p>
                </div>
              </div>
              <div class="faq">
                <h4><span>Q</span>After purchasing a monitoring service package, will I still be charged if the node is not configured and used?</h4>
                <div class="faq-info">
                  <span>A</span>
                  <p>Yes. The monitoring service is a subscription service. Once purchased, it is considered within the service period regardless of whether monitoring nodes are configured or used.</p>
                </div>
              </div>
              <div class="faq">
                <h4><span>Q</span>How many nodes can be added to the monitoring service package?</h4>
                <div class="faq-info">
                  <span>A</span>
                  <p>In theory, there's no limit to the number of nodes that can be added. However, considering management issues, it's recommended to purchase monitoring service packages based on your company's departmental structure or product lines. This approach facilitates future permission management.</p>
                </div>
              </div>
              <div class="faq">
                <h4><span>Q</span>How to monitor the deployment of intranet SSL certificates?</h4>
                <div class="faq-info">
                  <span>A</span>
                  <p>For intranet nodes, a monitoring agent needs to be added to collect SSL certificate information and then synchronize to the cloud. All management and monitoring panels are still processed in the cloud.</p>
                </div>
              </div>
            </div>
          </div>
  </div>
</template>

<script setup>
import { onMounted, nextTick, computed } from 'vue'

usePageSeo({
  title: "SSL Certificate Monitoring - SSL Certificate Monitoring Alert - NicSRS",
  description: "SSL Certificate Monitoring - SSL Certificate Monitoring Alert - NicSRS",
  bodyId: "monitoring-page",
})

</script>
